var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBefore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55589 16.5104C9.69667 16.3699 9.80836 16.2031 9.88457 16.0193C9.96077 15.8356 10 15.6387 10 15.4398C10 15.2409 9.96077 15.044 9.88457 14.8602C9.80836 14.6765 9.69667 14.5097 9.55589 14.3692L3.66361 8.47688L9.55588 2.5846C9.83983 2.30065 9.99936 1.91553 9.99936 1.51397C9.99936 1.1124 9.83983 0.727282 9.55588 0.443333C9.27193 0.159383 8.88682 -0.000135414 8.48525 -0.000135379C8.08369 -0.000135344 7.69857 0.159383 7.41462 0.443333L0.444112 7.41384C0.30333 7.55434 0.191638 7.72122 0.115431 7.90493C0.0392242 8.08864 -8.02188e-07 8.28558 -7.848e-07 8.48447C-7.67412e-07 8.68337 0.0392243 8.88031 0.115431 9.06402C0.191638 9.24773 0.30333 9.41461 0.444112 9.55511L7.41462 16.5256C7.9917 17.1027 8.96362 17.1027 9.55589 16.5104Z",
    fill: "#2F2F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBefore);
export default __webpack_public_path__ + "static/media/before.aad7ac2fc5e557d27fe22ac2bb96d110.svg";
export { ForwardRef as ReactComponent };